// extracted by mini-css-extract-plugin
export var captcha = "FooterDisclaimer-module--captcha--f7a63";
export var disclaimerText = "FooterDisclaimer-module--disclaimer-text--840b3";